import animations from '$/utils/animation/animation';

export function fixedFloat(num: number, decs = 2): number {
  return parseFloat(num.toFixed(decs));
}

export const getRandomness = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getNumberNotEqualPrev = (lastNumber: number): number => {
  if (animations.length <= 1) return 0;

  const num = getRandomness(0, animations.length - 1);
  if (lastNumber !== -1 && lastNumber === num) return getNumberNotEqualPrev(lastNumber);
  return num;
};

export const generateId = (index?: number): string =>
  `${(index || 0) + Math.random().toString(36).substr(2, 9)}`;

export const isNumber = (val?: number | null): boolean => {
  return val !== undefined && val !== null;
};

export const formatNumber = (value: number, fractionDigits = 1): string => {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      maximumFractionDigits: fractionDigits,
    }).format(value);
  } catch (error) {
    return value.toString();
  }
};

export const formatShortNumber = (value: number): string => {
  return (
    value > 999
      ? Math.sign(value) * Number((value / 1000).toFixed(1)) + 'K'
      : Math.sign(value) * value
  ) as string;
};
